module.exports = __webpack_public_path__ + "static/img/youshi3.3f7bba23.png";